document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.p-header');
  const ctaBanner = document.getElementById('cta-banner');

  let ticking = false;
  const update = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 0);
    ctaBanner.classList.toggle('fixed', window.scrollY < 40);
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  update();
  const menuBtn = document.getElementById('menu-btn');
  const navigation = document.getElementById('navigation');
  if (menuBtn && navigation) {
    menuBtn.addEventListener('click', () => {
      // メニューの表示/非表示を切り替える処理をここに追加
      console.log('Menu button clicked');
      const open = menuBtn.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open);
      navigation.classList.toggle('is-open', open);
    });
  }
  const toggleBtns = document.querySelectorAll('.c-toggle');
  toggleBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const content = btn.closest('.c-interview');
      const isOpen = content.classList.toggle('is-open');
      if (!isOpen) {
        const headerHeight = header ? header.offsetHeight : 0;
        const top = content.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scrollTo({ top, behavior: "smooth" });
      }
      btn.setAttribute('aria-expanded', String(isOpen));
      btn.textContent = isOpen ? '閉じる' : '続きを読む';

    });
  });

  const anchorLinks = document.querySelectorAll('a.anchor');
  anchorLinks.forEach(link => {
    link.addEventListener('click', (event) => {
      const open = menuBtn.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open);
      navigation.classList.toggle('is-open', open);
    });
  });

  document.querySelectorAll('.c-faq__q').forEach((btn) => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.c-faq__item');
      const isOpen = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(isOpen));
    });
  });

  const targets = document.querySelectorAll('.c-fade-in');
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target); // 一度だけ発火させる
      }
    });
  }, {
    threshold: 0.15,          // 要素が15%見えたら発火
    rootMargin: '0px 0px -50px 0px', // 下端より少し手前で発火させたい時に調整
  });
  targets.forEach((el) => observer.observe(el));
});


const bannerClass = () => {
  const banner = document.getElementById('cta-banner');
  const isPc = window.matchMedia('(min-width: 768px)').matches;
  if (banner) {
    if (isPc) {
      banner.classList.add('pcOn2');
      banner.classList.remove('spOn2');
    } else {
      banner.classList.add('spOn2');
      banner.classList.remove('pcOn2');
    }
  }
}
window.addEventListener('resize', bannerClass);
window.addEventListener('DOMContentLoaded', bannerClass);
